module.exports = __webpack_public_path__ + "896794007285b1ce4aac86a07ecad4df.pdf";